module.exports = __webpack_public_path__ + "static/media/2629972_card_cash_checkout_credit_mastercard_icon.8f8e50c0.svg";